import dayjs, { ConfigType } from "dayjs"
import { formatRelativeTime } from "./formatRelativeTime"

export const formatRelativeTimeFromNow = (toDate: ConfigType) => formatRelativeTime(dayjs(), toDate)
